export default __webpack_public_path__ + "1a274d94964324ac542995f56a3c1008.svg";